import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuizError = ({
  progressToNextContent
}) => /*#__PURE__*/_jsx(Flex, {
  blockSize: "100%",
  "data-test-id": "quiz-error-wrapper",
  inlineSize: "100%",
  justifyContent: "center",
  children: /*#__PURE__*/_jsx(View, {
    maxInlineSize: "500px",
    children: /*#__PURE__*/_jsxs(ErrorMessage, {
      type: "badRequest",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.quiz.genericError"
      }), /*#__PURE__*/_jsx(Link, {
        onClick: progressToNextContent,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.quiz.skipQuiz"
        })
      })]
    })
  })
});
export default QuizError;